import React from 'react'
import { useFormContext } from 'react-hook-form'

import InputHidden from '../inputs/InputHidden'
import FormError from '../../typography/FormError'

interface Props {
  disabled?: boolean
  errors?: string[] | string
  hideErrors?: boolean
  name?: string
  names?: string[]
  centered?: boolean
  /** Set this to true if you expect that the name for this form error is not a name of any of your inputs. */
  renderHiddenInput?: boolean
}

const FormErrorCTX: React.FC<Props> = (props) => {
  const {
    centered,
    disabled,
    errors,
    hideErrors,
    name,
    names,
    renderHiddenInput,
  } = props
  const ctx = useFormContext()
  const errorsFromCtx = ctx.errors

  if (!!hideErrors) {
    return null
  }

  if (!!renderHiddenInput && !name) {
    throw new Error(
      'Please pass in a name if you set renderHiddenInput to true.'
    )
  }

  const getError = (fieldName: string) => {
    if (!!errorsFromCtx[fieldName] && !!errorsFromCtx[fieldName].message) {
      return errorsFromCtx[fieldName].message
    }
    return undefined
  }

  let displayError

  if (!!name) {
    displayError = getError(name)
  }

  if (!!names && names.length > 0) {
    names.forEach((item) => {
      const error = getError(item)
      if (!!error) {
        displayError = error
      }
    })
  }

  if (!!errors) {
    displayError = typeof errors === 'string' ? errors : errors[0]
  }

  if (!!displayError) {
    return (
      <React.Fragment>
        <FormError disabled={disabled} centered={centered}>
          {displayError}
        </FormError>
        {!!renderHiddenInput && !!name && <InputHidden name={name} />}
      </React.Fragment>
    )
  }

  return null
}

export default FormErrorCTX
